import React from "react";
import { Lock } from "lucide-react";
import { PRIVACY_POLICY } from "../mock";
import { LegalPage } from "../components/LegalPage";
import useScrollReveal from "../hooks/useScrollReveal";
import useSEO from "../hooks/useSEO";

export default function PrivacyPolicy() {
  useScrollReveal();
  useSEO({
    title: "Privacy Policy | Miller & Miller Services LLC",
    description:
      "Privacy Policy for Miller & Miller Services LLC, including how we collect, use, and protect your personal information and SMS/text messaging data.",
    path: "/privacy-policy",
  });
  return (
    <LegalPage
      icon={Lock}
      title="Privacy Policy"
      breadcrumb="Privacy Policy"
      updated={PRIVACY_POLICY.updated}
      intro={PRIVACY_POLICY.intro}
      sections={PRIVACY_POLICY.sections}
    />
  );
}
